import { useQuery } from 'react-query';
import { TemplateQueryParams } from '../../../interfaces/queryParams';
import { IQueryRequest } from '../../../interfaces/request';
import { getDashboardTemplateOrganizationsGrasps } from '../../dashboards';
import QueryKeys from '../queryKeys';

const useDashboardTemplateOrganizationsGrasps = ({
  params,
  options,
}: IQueryRequest<TemplateQueryParams>) => {
  const { organizationId, templateId } = params;

  return useQuery({
    ...options,
    queryKey: [
      QueryKeys.getDashboardTemplateOrganizationsGrasps,
      organizationId,
      templateId,
    ],
    queryFn: async () => {
      const { data } = await getDashboardTemplateOrganizationsGrasps(
        organizationId,
        templateId
      );
      return data.data;
    },
  });
};

export default useDashboardTemplateOrganizationsGrasps;
